// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"275":"29409418","453":"e2cf34a8","683":"4f35d6e0","781":"7b61c87e"}[chunkId] + ".chunk.js";
};